import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getContacts, updateContacts } from '../../Store/contacts/contactsSlice';
import styles from '../../styles/AdminPanel.module.scss';

const EMPTY_PHONE = '';

const ContactsEditor = ({ showMessage }) => {
  const dispatch = useDispatch();
  const { data, isLoading } = useSelector((state) => state.contacts);

  const [phones, setPhones] = useState(['']);
  const [formData, setFormData] = useState({
    contactPerson: '',
    company: '',
    address: '',
    email: '',
    telegram: '',
    viber: '',
  });

  useEffect(() => {
    dispatch(getContacts());
  }, [dispatch]);

  useEffect(() => {
    if (!data) return;
    setPhones(data.phones?.length ? [...data.phones] : ['']);
    setFormData({
      contactPerson: data.contactPerson || '',
      company: data.company || '',
      address: data.address || '',
      email: data.email || '',
      telegram: data.telegram || '',
      viber: data.viber || '',
    });
  }, [data]);

  const updatePhone = (index, value) => {
    setPhones((prev) => prev.map((item, i) => (i === index ? value : item)));
  };

  const addPhone = () => {
    setPhones((prev) => [...prev, EMPTY_PHONE]);
  };

  const removePhone = (index) => {
    setPhones((prev) => (prev.length > 1 ? prev.filter((_, i) => i !== index) : ['']));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const filledPhones = phones.map((p) => p.trim()).filter(Boolean);
    if (!filledPhones.length) {
      showMessage('error', 'Додайте хоча б один телефон');
      return;
    }

    try {
      await dispatch(updateContacts({
        phones: filledPhones,
        ...formData,
      })).unwrap();
      showMessage('success', 'Контакти успішно збережено');
    } catch (error) {
      showMessage('error', error || 'Помилка при збереженні контактів');
    }
  };

  return (
    <div className={styles.contactsEditor}>
      <form onSubmit={handleSubmit} className={styles.contactsEditorForm}>
        <section className={styles.contactsEditorSection}>
          <h3>Телефони</h3>
          <div className={styles.contactsEditorPhones}>
            {phones.map((phone, index) => (
              <div key={index} className={styles.contactsEditorPhoneRow}>
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => updatePhone(index, e.target.value)}
                  placeholder="+380 (97) 000-00-00"
                />
                <button type="button" onClick={() => removePhone(index)} disabled={phones.length === 1}>
                  Видалити
                </button>
              </div>
            ))}
            <button type="button" className={styles.contactsEditorAddBtn} onClick={addPhone}>
              + Додати телефон
            </button>
          </div>
        </section>

        <section className={styles.contactsEditorSection}>
          <h3>Контактна інформація</h3>
          <div className={styles.contactsEditorGrid}>
            <label>
              Контактна особа
              <input
                type="text"
                name="contactPerson"
                value={formData.contactPerson}
                onChange={handleChange}
                placeholder="Арк Детали"
              />
            </label>
            <label>
              E-mail
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="ark-kharkov@ukr.net"
              />
            </label>
            <label className={styles.contactsEditorFull}>
              Компанія
              <textarea
                name="company"
                value={formData.company}
                onChange={handleChange}
                rows={3}
                placeholder="Автомагазин ARKdetali - запчастини, ремонт та догляд за авто"
              />
            </label>
            <label className={styles.contactsEditorFull}>
              Адреса
              <textarea
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows={2}
                placeholder="Пісочин, Харківська область, Харків, Україна"
              />
            </label>
            <label>
              Telegram
              <input
                type="text"
                name="telegram"
                value={formData.telegram}
                onChange={handleChange}
                placeholder="+38(097) 583-10-04"
              />
            </label>
            <label>
              Viber
              <input
                type="text"
                name="viber"
                value={formData.viber}
                onChange={handleChange}
                placeholder="+38(099) 490-25-39"
              />
            </label>
          </div>
        </section>

        <div className={styles.contactsEditorActions}>
          <button type="submit" disabled={isLoading}>
            {isLoading ? 'Збереження…' : 'Зберегти'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ContactsEditor;
